import classNames from "classnames";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ampli } from "../../../ampli";
import OutlinedButton from "../../../components/common/OutlinedButton";
import PrimaryButton from "../../../components/common/PrimaryButton";
// styles
import styles from "./newTransaction.module.scss";

interface Props {
  contractId: string;
  shortId: string;
  onClose: () => void;
  editContract?: boolean;
}

const SuccessForm = ({ contractId, shortId, onClose, editContract }: Props) => {
  const url = location.href;
  const contractUrl = `${url}contract/${contractId}`;
  const [copied, setCoppied] = useState(false);
  const { t } = useTranslation();

  const onCopy = async () => {
    try {
      await navigator?.clipboard?.writeText(contractUrl);
      setCoppied(true);
      ampli.sharedContract({
        shareContractPageSource: "contractWizardPage", // enum,
        shareContractMethod: "Others", // enum,
        contractId: shortId,
      });
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className={styles["form"]}>
      <div className={styles["top_section"]}>
        <div className={styles["contract_image_container"]}>
          <img
            className={styles["contract_image"]}
            src="/assets/images/svg/contract.svg"
          />
        </div>
        <div className={styles["success_text_wrapper"]}>
          <h1>
            {editContract
              ? `${t("EDITED_SUCCESSFULLY")}`
              : `${t("CREATED_SUCCESSFULLY")}`}
          </h1>
          <p className={"p1"}>{t("COPY_LINK")}</p>
        </div>
        {!editContract && (
          <div className={styles["link_box"]}>
            <div className={styles["copy_button"]}>
              <PrimaryButton
                id={`create_contract_success_copy_link`}
                onClick={() => (copied ? onClose() : onCopy())}
                {...(copied && { backgroundColor: "#44C16E" })}>
                {copied ? t("COPIED") : t("COPY")}
              </PrimaryButton>
            </div>
            <div className={styles["link_container"]}>
              <p className={classNames("p4", styles["contract_link"])}>
                {contractUrl}
              </p>
            </div>
            <div className={styles["clip_container"]}>
              <img
                className={styles["clip_image"]}
                src="/assets/images/svg/clip.svg"
              />
            </div>
          </div>
        )}
      </div>
      <div className={styles.bottom_section}>
        <OutlinedButton id={`create_contract_success_close`} onClick={onClose}>
          {t("lbl_close_button")}
        </OutlinedButton>
      </div>
    </div>
  );
};

export default React.memo(SuccessForm);
